var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"main-view modal\" role=\"dialog\" data-backdrop=\"static\"\u003E\u003Cdiv class=\"modal-dialog modal-lg\" role=\"document\"\u003E\u003Cdiv class=\"modal-content\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"modal-footer-description\"\u003EDSGVO\u002FGDPR conform by RuSs.CiTy\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src-cookie-manager/views/main/template.pug
// module id = 572
// module chunks = 0